import Promise from 'promise'
import agent from 'superagent'
import global from 'modules/global'

function doGet(request) {
  return new Promise(function(resolve, reject) {
    var req = agent.get(global.api + request.endpoint)
    if(request.token) {
      req.set('Authorization', 'Bearer ' + request.token)
    }
    req
    .query(request.data)
    .withCredentials()
    .end((err, res) => {
      resolve(res || {
        status:600,
        body:err
      })
    })
  })
}
function doDownload(request) {
  return new Promise(function(resolve, reject) {
    location.href = global.api + request.endpoint
    resolve()
  })
}
function doUpload(request) {
  return new Promise(function(resolve, reject) {
    var req = agent.post(global.api + request.endpoint)
    if(request.token) {
      req.set('Authorization', 'Bearer ' + request.token)
    }
    var formData = new FormData()
    Object.keys(request.data).forEach(function(key) {
      formData.append(key, request.data[key])
    })
    req
    .send(formData)
    .withCredentials()
    .end((err, res) => {
      resolve(res || {
        status:600,
        body:err
      })
    })
  })
}
function doPut(request) {
  return new Promise(function(resolve, reject) {
    var req = agent.put(global.api + request.endpoint)
    if(request.token) {
      req.set('Authorization', 'Bearer ' + request.token)
    }
    if(request.data) req.send(request.data)
    if(request.formdata) req.send(request.formdata)
    req
    .withCredentials()
    .end((err, res) => {
      resolve(res || {
        status:600,
        body:err
      })
    })
  })
}
function doPost(request) {
  return new Promise(function(resolve, reject) {
    var req = agent.post(global.api + request.endpoint)
    if(request.token) {
      req.set('Authorization', 'Bearer ' + request.token)
    }
    req
    .send(request.data)
    .withCredentials()
    .end((err, res) => {
      resolve(res || {
        status:600,
        body:err
      })
    })
  })
}
function doDelete(request) {
  return new Promise(function(resolve, reject) {
    var req = agent.delete(global.api + request.endpoint)
    if(request.token) {
      req.set('Authorization', 'Bearer ' + request.token)
    }
    req
    .withCredentials()
    .end((err, res) => {
      resolve(res || {
        status:600,
        body:err
      })
    })
  })
}
var method = {
  post:doPost,
  upload:doUpload,
  download:doDownload,
  get:doGet,
  put:doPut,
  delete:doDelete
}
function request(request) {
  return method[request.method || 'get'](request)
}
module.exports = request



// WEBPACK FOOTER //
// ./src/modules/request.js